module.exports = __webpack_public_path__ + "img/back centered zipper length.98784dc0.png";